import React, { useEffect } from "react";
import { ResponsiveCarousel } from "./ResponsiveCarousel";
import { useGetBannerListQuery } from "../../../Services/SettingsService";
import { useSelector } from "react-redux";
import { useLazyGetCountryDialingListQuery } from "../../../Services/CountryService";
import Constant from "../../../Config/Constant";
import Storage from "../../../Helpers/Storage";

const Banner: React.FC = () => {
  const countryDialingList = useSelector(
    (state: any) => state.SettingSlice.countryDialingList,
  );
  const [getCountryDialing] = useLazyGetCountryDialingListQuery();

  useEffect(() => {
    getCountryList();
  }, []);

  const getCountryList = async () => {
    setTimeout(() => {
      const lastFetch = Number(Storage.get(Constant.DAILY_REFRESH_KEY));
      const now = Date.now();
      const oneDay = 86400000; // 24 * 60 * 60 * 1000
      const shouldFetch =
        !lastFetch || now - lastFetch > oneDay || !countryDialingList?.length;
      if (shouldFetch) {
        getCountryDialing();
        Storage.set(Constant.DAILY_REFRESH_KEY, now.toString());
      }
    }, 3000);
  };

  // No page/pageSize: the storefront wants every ACTIVE banner, not the first
  // five. isActive in Admin is the control over what shows -- a hidden cap here
  // silently contradicted it, so activating a 6th banner did nothing.
  useGetBannerListQuery();

  return (
    <div className="w-full md:mx-auto md:px-16 bg-white dark:bg-dark-background transition-colors">
      <div className="w-full">
        <ResponsiveCarousel />
      </div>
    </div>
  );
};

export default Banner;
